"use client"
import React from "react";

export default function InfoCTA(props) {
    const {
        reverse = false,
        className = "red-color",
        text = "Join Waitlist",
        id = "consumer-join-poln",
        link,
    } = props

    const handleClick = (link) => {
        window.open(link, '_blank');
    };

    return (<>
        <div className={`d-flex ${reverse ? "justify-content-start" : "justify-content-end"} mt-4 mb-4 mr-10`}>
            <div onClick={() => handleClick(handleClick(link))}
                 className={`theme-btn wow fadeInUp rounded-pill cursor-pointer ${className}`}
                 data-wow-duration="1s" id={id}>
                {text}
            </div>
        </div>
    </>);
}
